<div class="d-flex basic-layout">
  <div class="sidebar d-lg-flex" [class.not-expanded]="!mobileSidebarExpanded">
    <cap-sidebar-menu
      [isExpanded]="isExpanded()"
      [menus]="menus"
      [expandable]="true"
      (onExpand)="setExpandedStatus($event)">
      <a brand class="sidebar__brand-link" routerLink="/" aria-label="ENEQTO — home">
        <app-eneqto-logo [expanded]="isExpanded()" />
      </a>
    </cap-sidebar-menu>
  </div>

  <div class="content d-flex flex-column w-100">
    <div class="basic-layout__header">
      <app-header />
    </div>

    <div class="basic-layout__content page-wrapper">
      <router-outlet />
    </div>
  </div>
</div>
